import React, { ChangeEvent, ReactNode } from 'react';
import './style.scss';
import { MultiSelectionsItem } from 'views/templates/accountOpen/common';
import { FormError } from '../formErrorScroll';

export type InputRadioProps = {
  label: string | ReactNode;
  name: string;
  value: string;
  checked?: boolean | undefined;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  addtional?: React.ReactNode;
  disabled?: boolean;
};

export const InputRadio = (props: InputRadioProps) => {
  const { label, name, value, checked, onChange, addtional, disabled = false } = props;
  return (
    <>
      <label className="inputRadio">
        <input type="radio" name={name} value={value} checked={checked} onChange={onChange} disabled={disabled} />
        <div className="inputRadio_labels">
          <span>{label}</span>
          <span>{addtional}</span>
        </div>
      </label>
    </>
  );
};

export type TwoSelectionsProps = {
  labelYes?: string;
  labelNo?: string;
  name: string;
  selected?: boolean | null;
  onChange?: (value: boolean) => void;
  addtionalYes?: React.ReactNode;
  addtionalNo?: React.ReactNode;
  disabledYes?: boolean | null;
  disabledNo?: boolean | null;
  error?: string | undefined;
};

export const TwoSelections = (props: TwoSelectionsProps) => {
  const { labelYes, labelNo, name, selected, onChange, addtionalYes, addtionalNo, disabledYes, disabledNo, error } = props;

  const handleChange = (status: boolean) => {
    return (event: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange && event.target.checked) {
        onChange!(status);
      }
    };
  };

  return (
    <div className="twoSelections">
      <fieldset className="twoSelections_yesOrNo">
        <InputRadio
          label={labelYes || "はい"}
          name={name}
          value="true"
          checked={selected !== null && selected}
          onChange={handleChange(true)}
          addtional={addtionalYes}
          disabled={disabledYes !== null && disabledYes}
        ></InputRadio>

        <InputRadio
          label={labelNo || "いいえ"}
          name={name}
          value="false"
          checked={selected !== null && !selected}
          onChange={handleChange(false)}
          addtional={addtionalNo}
          disabled={disabledNo !== null && disabledNo}
        />
      </fieldset>
      <FormError className="twoSelections_error" error={error} />
    </div>
  );
};

export type MultiSelectionsDataProps = {
  selected?: any;
  onChange?: (value: any) => void;
  disabled?: boolean;
  error?: string | undefined;
};

export enum Direction{
  column = 'column',
  row = 'row',  
}

export type MultiSelectionsProps = {
  name: string;
  items: MultiSelectionsItem[];
  direction?: Direction;
} & MultiSelectionsDataProps;

export const MultiSelections = (props: MultiSelectionsProps) => {
  const { name, items, selected, onChange, disabled = false, direction = Direction.column, error } = props;

  const handleChange = (target: any) => (e: ChangeEvent<HTMLInputElement>) => {
    if (onChange && e.target.checked) {
      onChange(target);
    }
  };

  return (
    <div className="multiSelections">
      <fieldset className={`multiSelections_items multiSelections_${direction}`}>
        {items.map((item) => {
          return (
            <InputRadio
              label={item.label}
              name={name}
              value={item.value}
              checked={selected === item.value}
              onChange={handleChange(item.value)}
              disabled={item.disabled != null ? item.disabled : disabled}
              addtional={item.additional}
            />
          );
        })}
      </fieldset>
      <FormError className="multiSelections_error" error={error} />
    </div>
  );
};
